import React, {useEffect, useRef, useState} from 'react';
import {Form, InputGroup, OverlayTrigger, Popover, ProgressBar} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faEye, faEyeSlash, faXmark} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";


const PasswordMeter = ({text = 'Password',onSufficientPassword, onUnSufficientPassword, sufficientScore = 4, ...props}) => {
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const scoreWasSufficient = useRef(false)

    const {t} = useTranslation()

    function validatePassword(password) {
        let score = 0;
        const minLength = 8;

        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /\d/.test(password);

        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        let scoreOverview = {
            passwordLength: {
                value: false,
                text: t('dialogs.passwordMeter.requirements.length')
            },
            lowerAndUpperCase: {
                value: false,
                text: t('dialogs.passwordMeter.requirements.lowerUpperCase')
            },
            number: {
                value: false,
                text: t('dialogs.passwordMeter.requirements.number')
            },
            specialChar: {
                value: false,
                text: t('dialogs.passwordMeter.requirements.specialCharacter')
            }
        };

        if (password.length >= minLength) {
            score++;
            scoreOverview.passwordLength.value = true;
        }
        if (hasUpperCase && hasLowerCase) {
            score++;
            scoreOverview.lowerAndUpperCase.value = true;
        }
        if (hasNumber) {
            score++;
            scoreOverview.number.value = true;
        }
        if (hasSpecialChar) {
            score++;
            scoreOverview.specialChar.value = true
        }

        return {
            scoreOverview,
            score
        };
    }

    const { score, scoreOverview} = validatePassword(password);

    useEffect(() => {
        if(score >= sufficientScore)
        {
            scoreWasSufficient.current = true
            onSufficientPassword(password)
        }
        else if(scoreWasSufficient)
        {
            scoreWasSufficient.current = false
            onUnSufficientPassword()
        }

    }, [score, sufficientScore, password]);

    const getScoreInfo = () => {
        switch (score) {
            case 0:
            case 1:
                return {
                    variant: 'danger',
                    message: t('dialogs.passwordMeter.passwordStrength.weak')
                }

            case 2:
            case 3:
                return {
                    variant: 'warning',
                    message: t('dialogs.passwordMeter.passwordStrength.medium')
                }
            default:
                return {
                    variant: 'success',
                    message: t('dialogs.passwordMeter.passwordStrength.strong')
                }
        }
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const scoreInfo = getScoreInfo()

    const ConditionalLi = ({condition}) => (
        <div className='d-flex align-items-center'>
            {condition.value ?
                <>
                    <FontAwesomeIcon icon={faCheck} color='green' className='me-2'/>
                    <span>{condition.text}</span>
                </>
                :
                <>
                    <FontAwesomeIcon icon={faXmark} color='red' className='me-2'/>
                    <span style={{color: 'red'}}>{condition.text}</span>
                </>
            }
        </div>
    )

    const overlay = (
        <Popover id="popover-basic">
            <Popover.Body>
                <div className='d-flex flex-column'>
                    <ConditionalLi condition={scoreOverview.passwordLength}/>
                    <ConditionalLi condition={scoreOverview.lowerAndUpperCase}/>
                    <ConditionalLi condition={scoreOverview.number}/>
                    <ConditionalLi condition={scoreOverview.specialChar}/>
                </div>
            </Popover.Body>
        </Popover>
    )

    return (
        <div {...props}>
            <Form.Group controlId="formPassword">
                <Form.Label>{text}</Form.Label>
                <InputGroup>
                    <OverlayTrigger overlay={overlay} trigger='focus'>
                        <Form.Control
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={t('dialogs.passwordMeter.placeholder')}
                        />
                    </OverlayTrigger>
                    <InputGroup.Text onClick={toggleShowPassword} className='d-flex justify-content-center align-items-center' style={{ cursor: 'pointer', width: '45px' }}>
                        <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                    </InputGroup.Text>
                </InputGroup>
            </Form.Group>
            <ProgressBar
                now={score * 25}
                max={100}
                variant={scoreInfo.variant}
                style={{ height: '5px', marginTop: '10px' }}
            />
            <span>{scoreInfo.message}</span>
        </div>
    )
};

export default PasswordMeter;